import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import Groups from "../groups";
import Products from "../products";
import useSettings from "../hooks/useSettings";

const ConfigurableProducts = ({ context }) => {
  const settings = useSettings();
  const [forCategory, setForCategory] = useState(null);
  const [level, setLevel] = useState(1);
  const [groupId, setGroupId] = useState(null);
  const handleFilterChange = ({ groupId, level, forCategory }) => {
    console.log("Filter Change", groupId, level, forCategory);
    setGroupId(groupId || "all");
    setLevel(level);
    setForCategory(forCategory);
  };

  useEffect(() => {
    let category = null;
    let url = window.location.href;
    if (url.indexOf("servers") > -1) {
      category = "servers";
    } else if (url.indexOf("storage") > -1) {
      category = "storage";
    } else if (url.indexOf("switches") > -1) {
      category = "switches";
    }
    if (category === null) {
      //Defautl for now
      category = "servers";
    }
    setForCategory(category);
  }, [context]);
  return (
    <div>
      <Groups
        forCategory={forCategory}
        level={2}
        context={context}
        onFilterChange={handleFilterChange}
      />
      <Products forCategory={forCategory} level={level} groupId={groupId} />
      {settings.showTouchPoints && (
        <div className="container">
          <div
            className="sb-display-flex"
            style={{ alignItems: "stretch", marginTop: "60px" }}
          >
            <div
              className="sb-display-flex sb-bg-orange"
              style={{ width: "60%", padding: "30px" }}
            >
              <div>
                <div>
                  <img
                    style={{ width: "40px", marginBottom: "5px" }}
                    src={window.cdn(
                      "/img/sb-theme/home/contact-points/chat-icon.png"
                    )}
                  />
                  <h1 className="sb-bg-orange">
                    Can't find what you're looking for?
                  </h1>
                </div>
                {/* <p>
                Looking for HPE experts? With 24/7 support, our team of experts
                are always ready to help.
              </p> */}
                <a href="/contact-us" className="sb-btn-link">
                  Chat with our team
                </a>
              </div>
            </div>
            <div style={{ width: "40%" }}>
              <img src={window.cdn("/img/sb-theme/product/contact.jpg")} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfigurableProducts;
